export const TYPES = {
  SET_CUSTOM_DISTRACTORS_PROPS: 'setCustomDistractorsProps',
};

export const defaultValues = {
  customDistractorsProps: {},
};
export const reducer = (state, action) => {
  switch (action.type) {
    case TYPES.SET_CUSTOM_DISTRACTORS_PROPS: {
      return {
        ...state,
        customDistractorsProps: {
          ...state.customDistractorsProps,
          [action.payload.questionReference]:
            action.payload.customDistractorsProps,
        },
      };
    }
    default:
      throw Error(`Unknown action: ${action.type}`);
  }
};
